import { gql } from '@apollo/client';

export interface ProfileCompletion_FundingLimitRequest {
  uuid: string;
  employerUuid: string;
}

export interface ProfileCompletion_FundingLimit {
  profileCompletion_getUserFundingLimit: {
    fundingLimitAmount?: number;
  };
}

export const GET_USER_FUNDING_LIMIT = gql`
  query GetUserFundingLimit($uuid: ID!, $employerUuid: ID!) {
    profileCompletion_getUserFundingLimit(uuid: $uuid, employer_uuid: $employerUuid) {
      fundingLimitAmount: funding_limit_amount
    }
  }
`;
